import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'xm-radio',
    styleUrls: ['./radio.scss'],
    templateUrl: './radio.html',
    standalone: false
})
export class XmRadioComponent implements OnInit {
    @Input() public option: XmRadioOption;
    @Input() public smallMainLabel: boolean = true;

    public labelFor: string;
    public ariaDescribedby: string;

    public ngOnInit(): void {
        this.labelFor = `${this.option.groupName}-${this.option.labelFor || this.option.label}`.replace(/\s+/g, '');
        this.ariaDescribedby = this.option.ariaDesc ? `aria-${this.option.groupName} ${this.option.ariaDesc}` : `aria-${this.option.groupName}`;
    }
}
